'use client';

import classNames from 'classnames';

import { ProjectSettingsModeGroupEnum } from '@/app/api';
import { PropsWithClassname } from '@/app/types';

import Collapsible from '@/app/components/Collapsible/Collapsible';
import Loader from '@/app/components/Loader/Loader';
import SubprojectBanner from '@/app/components/SubprojectBanner/SubprojectBanner';
import { countryConfig } from '@/app/utils/countryConfig';
import { useGetProjectFaqs } from '@/src/api/client';

interface ProjectFAQTabProps extends PropsWithClassname {
  projectId: string;
  projectNumericId: number;
  isSubprojectBannerVisible?: boolean;
  projectType: ProjectSettingsModeGroupEnum;
}

const ProjectFAQTab = ({
  projectId,
  projectNumericId,
  isSubprojectBannerVisible,
  className,
  projectType,
}: ProjectFAQTabProps) => {
  const { isLoading, data } = useGetProjectFaqs(
    {
      project: projectId,
    },
    { query: { queryKey: ['projectFaqs'] } },
  );

  return (
    <div className={classNames(className, 'flex flex-col items-center')}>
      {isLoading && <Loader />}
      {!isLoading && (
        <>
          {data?.faqs.map((faq) => {
            if (!faq.question || !faq.answer) {
              return;
            }

            return <Collapsible key={faq.id} heading={faq.question} text={faq.answer} />;
          })}

          {countryConfig.faqs[projectType].map(([question, answer]) => (
            <Collapsible key={question} heading={question} text={answer} />
          ))}
        </>
      )}
      {isSubprojectBannerVisible && <SubprojectBanner projectNumericId={projectNumericId} className="mt-[40px]" />}
    </div>
  );
};

export default ProjectFAQTab;
